const BASE_URL = '/'
const AUTH = BASE_URL
const HOME = `${BASE_URL}home`
const ADMIN = `${BASE_URL}admin`
const ADMIN_ORCAMENTOS = `${ADMIN}/orcamentos`
const ADMIN_SINCRONIZACOES = `${ADMIN}/sincronizacoes`
const ADMIN_CC_BLOQUEADOS = `${ADMIN}/centros-custos-bloqueados`
const ADMIN_PERIODOS_ANALISE_ORCAMENTARIA = `${ADMIN}/periodos-analise-orcamentaria`
const ADMIN_PERIODOS_EVENTOS = `${ADMIN}/periodos-eventos`
const ADMIN_NOMES_EVENTOS = `${ADMIN}/nomes-eventos`
const ADMIN_USUARIOS_PERMISSAO = `${ADMIN}/usuarios-permissao`
const ADMIN_IMPORTACAO = `${ADMIN}/importacao`
const CC_DETALHES = `${BASE_URL}centro-de-custo/:codCCustoPai`
const PREENCHIMENTO = `${BASE_URL}preenchimento`
const METAS = `${BASE_URL}metas`
const EVENTOS = `${BASE_URL}eventos`
const ANALISE_ORCAMENTARIA = `${BASE_URL}analise-orcamentaria`
const EMBEDS = `${BASE_URL}embeds`
const EMBEDS_PORWER_BI = `${EMBEDS}/power-bi`
const RELATORIOS = `${BASE_URL}relatorios`
const RELATORIO_CONFERIR_PREENCHIMENTO = `${RELATORIOS}/conferir-preenchimento`
const RELATORIO_TRIMESTRAL = `${RELATORIOS}/trimestral`
const RELATORIO_TRIMESTRAL_POR_REGIONAL = `${RELATORIOS}/trimestral-por-regional`
const RELATORIO_RECEITAS = `${RELATORIOS}/receitas`
const RELATORIO_EVENTOS = `${RELATORIOS}/eventos`
const RELATORIO_EXPORTACAO = `${RELATORIOS}/exportacao`
const RELATORIO_ORCAMENTARIO = `${RELATORIOS}/orcamentario`
const RELATORIO_ORCAMENTARIO_TRIMESTRAL = `${RELATORIOS}/orcamentario-trimestral`
const RELATORIO_ORCAMENTARIO_COMPARATIVO = `${RELATORIOS}/orcamentario-comparativo`
const RELATORIO_ORCAMENTARIO_COMPARATIVO_ANO = `${RELATORIOS}/orcamentario-comparativo-ano`
const RELATORIO_MEMORIA_CALCULO = `${RELATORIOS}/memoria-calculo`
const RELATORIO_ORCAMENTO_TEMPO_REAL = `${RELATORIOS}/orcamento-tempo-real`
const RELATORIO_TOTAIS_CENTRO_CUSTO = `${RELATORIOS}/totais-centro-custo`
const RELATORIO_IMPORTACAO_SISTEGO = `${RELATORIOS}/importacao-sistego`
const RELATORIO_ANALISE_ORCAMENTARIA = `${RELATORIOS}/analise-orcamentaria`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  AUTH,
  HOME,
  ADMIN,
  ADMIN_ORCAMENTOS,
  ADMIN_SINCRONIZACOES,
  ADMIN_CC_BLOQUEADOS,
  ADMIN_PERIODOS_ANALISE_ORCAMENTARIA,
  ADMIN_PERIODOS_EVENTOS,
  ADMIN_NOMES_EVENTOS,
  ADMIN_USUARIOS_PERMISSAO,
  ADMIN_IMPORTACAO,
  CC_DETALHES,
  PREENCHIMENTO,
  METAS,
  EVENTOS,
  ANALISE_ORCAMENTARIA,
  EMBEDS,
  EMBEDS_PORWER_BI,
  RELATORIOS,
  RELATORIO_CONFERIR_PREENCHIMENTO,
  RELATORIO_TRIMESTRAL,
  RELATORIO_TRIMESTRAL_POR_REGIONAL,
  RELATORIO_RECEITAS,
  RELATORIO_EVENTOS,
  RELATORIO_EXPORTACAO,
  RELATORIO_ORCAMENTARIO,
  RELATORIO_ORCAMENTARIO_TRIMESTRAL,
  RELATORIO_ORCAMENTARIO_COMPARATIVO,
  RELATORIO_ORCAMENTARIO_COMPARATIVO_ANO,
  RELATORIO_MEMORIA_CALCULO,
  RELATORIO_ORCAMENTO_TEMPO_REAL,
  RELATORIO_TOTAIS_CENTRO_CUSTO,
  RELATORIO_IMPORTACAO_SISTEGO,
  RELATORIO_ANALISE_ORCAMENTARIA,
  UNAUTHORIZED,
}
